import {Component, OnInit} from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-grammar-overview',
  templateUrl: './grammar-overview.component.html',
  styleUrl: './grammar-overview.component.scss',
  standalone: false
})
export class GrammarOverviewComponent implements OnInit {

  content: string = undefined;
  private httpClient: HttpClient;

  constructor(http: HttpClient) {
    this.httpClient = http;
  }

  ngOnInit() {
    this.httpClient.get('assets/md/grammar-overview.md', {responseType: 'text'}).subscribe(data => {
      this.content = data;
    });
  }
}
